import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import ProductCard from '@/components/ProductCard';
import { SlidersHorizontal } from 'lucide-react';
import { getApiUrl } from '@/utils/api';

const API = getApiUrl();

const Catalog = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterCategory, setFilterCategory] = useState('all');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API}/products`);
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = filterCategory === 'all'
    ? products
    : products.filter(p => p.category === filterCategory);

  const categories = [
    { id: 'all', label: 'Todos' },
    { id: 'graphic', label: 'Gráficas' },
    { id: 'limited', label: 'Edição Limitada' }
  ];

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="catalog-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4" data-testid="catalog-title">
            CATÁLOGO <span className="text-primary">COMPLETO</span>
          </h1>
          <p className="text-zinc-400 text-lg">Explore toda nossa coleção de camisetas exclusivas</p>
        </motion.div>

        {/* Filters */}
        <div className="mb-8 flex flex-wrap items-center gap-4" data-testid="catalog-filters">
          <div className="flex items-center gap-2 text-white">
            <SlidersHorizontal className="h-5 w-5" />
            <span className="font-mono text-sm uppercase tracking-wider">Filtrar:</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setFilterCategory(category.id)}
                className={`px-4 py-2 text-sm uppercase tracking-wider transition-colors ${
                  filterCategory === category.id
                    ? 'bg-primary text-black font-bold'
                    : 'bg-zinc-900 text-zinc-400 hover:text-white border border-white/10'
                }`}
                data-testid={`filter-${category.id}`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-20" data-testid="loading-indicator">
            <div className="inline-block h-16 w-16 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <motion.div
            layout
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
            data-testid="products-grid"
          >
            {filteredProducts.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </motion.div>
        )}

        {filteredProducts.length === 0 && !loading && (
          <div className="text-center py-20" data-testid="no-products-message">
            <p className="text-zinc-400 text-lg">Nenhum produto encontrado nesta categoria.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Catalog;